export function parseMatchData(currentMatch) {
  try {
    let matchStats = {};
    if (!currentMatch) return matchStats;

    const scoreA = currentMatch?.inn_score_1?.split(" ")[0] + (currentMatch?.inn_score_3?.split(" ")[0]?" | "+currentMatch?.inn_score_3?.split(" ")[0]:"") || "";
    const scoreB = currentMatch?.inn_score_2?.split(" ")[0] + (currentMatch?.inn_score_4?.split(" ")[0]?" | "+currentMatch?.inn_score_4?.split(" ")[0]:"") || "";
    
    const oversA =
      (currentMatch?.inn_score_1?.match(/(\d+\.\d+) ov/) &&
        currentMatch?.inn_score_1?.match(/(\d+\.\d+) ov/)[1]) ||
      "";
    const oversB =
      (currentMatch?.inn_score_2?.match(/(\d+\.\d+) ov/) &&
        currentMatch?.inn_score_2?.match(/(\d+\.\d+) ov/)[1]) ||
      "";
    const matchDateTime = new Date(
      currentMatch.matchdate_ist + "T" + currentMatch.matchtime_ist
    );

  matchStats.id = currentMatch?.match_id || currentMatch?.match_Id || 0;
  matchStats.type = currentMatch?.matchtype;
  matchStats.match_date = matchDateTime.toLocaleDateString("en-US", {
    weekday: "long",
    month: "short",
    day: "numeric",
  });
  matchStats.match_date_alt = matchDateTime.toLocaleDateString("en-US", {
    weekday: "short",
    day: "2-digit",
    month: "short",
  });
  matchStats.match_time = matchDateTime.toLocaleTimeString("en-US", {
    hour: "2-digit",
    minute: "2-digit",
    hour12: true,
  });

  matchStats.teamA_name = currentMatch?.teama_short?.toLowerCase();
  matchStats.teamB_name = currentMatch?.teamb_short?.toLowerCase();
  matchStats.altLogoA = currentMatch?.teama_short=="IND"?"https://akm-img-a-in.tosshub.com/lingo/nwtak/resources/1126.png":currentMatch?.teama_short=="ENG"?"https://akm-img-a-in.tosshub.com/lingo/nwtak/resources/1121.png":null;
  matchStats.altLogoB = currentMatch?.teamb_short=="IND"?"https://akm-img-a-in.tosshub.com/lingo/nwtak/resources/1126.png":currentMatch?.teamb_short=="ENG"?"https://akm-img-a-in.tosshub.com/lingo/nwtak/resources/1121.png":null;
  matchStats.teama_logo = currentMatch?.teama_flag;
  matchStats.teamb_logo = currentMatch?.teamb_flag;
  matchStats.teamA_score =
    currentMatch.inn_team_1 == currentMatch?.teama_id ||
    currentMatch.inn_team_1 == currentMatch?.teama_Id
      ? scoreA
      : scoreB;
  matchStats.teamB_score =
    currentMatch.inn_team_1 == currentMatch?.teamb_id ||
    currentMatch.inn_team_1 == currentMatch?.teamb_Id
      ? scoreA
      : scoreB;
  matchStats.match_no = currentMatch?.matchnumber;
  matchStats.teamA_overs =
    currentMatch.inn_team_1 == currentMatch?.teama_id ||
    currentMatch.inn_team_1 == currentMatch?.teama_Id
      ? oversA
      : oversB;
  matchStats.teamB_overs =
    currentMatch.inn_team_1 == currentMatch?.teamb_id ||
    currentMatch.inn_team_1 == currentMatch?.teamb_Id
      ? oversA
      : oversB;
  matchStats.equation =
    currentMatch?.equation == "" || !currentMatch?.equation
      ? currentMatch?.matchstatus
      : currentMatch?.equation;
  matchStats.status = (() => {
        const status = currentMatch?.matchstatus?.toLowerCase() || "";
        if (status.includes("match ended") || status.includes("match postponed") || status.includes("match abandoned")) {
          return "ENDED";
        }
        if (status.includes("match begins at")) {
          return "UPCOMING";
        }
        return "LIVE";
      })();
 
    
    const winningTeamId = currentMatch?.winningteam_id || currentMatch?.winningteam_Id;
    const teamAId = currentMatch?.teama_id || currentMatch?.teama_Id;

    matchStats.winning_team =
      matchStats.status === "ENDED" && winningTeamId
        ? winningTeamId === teamAId
          ? "A"
          : "B"
        : "";

    matchStats.batting_team =
      matchStats.status != "LIVE"
        ? null
        : currentMatch?.currentBattingTeam &&
          currentMatch?.currentBattingTeam.toLowerCase() ==
            currentMatch?.teama_short.toLowerCase()
        ? // (currentMatch?.current_batting_team == currentMatch?.teama_id ||
          //   currentMatch?.current_batting_team == currentMatch?.teama_Id)
          "A"
        : "B";

  matchStats.url = `/sports/${currentMatch.series_id=="8307"?"ipl":"cricket"}/${currentMatch?.page_slug_st}/${
    matchStats.status == "UPCOMING"
      ? "info"
      : matchStats.status == "LIVE"
      ? "live"
      : "summary"
  }`;
  return matchStats;
}catch(err){
  console.log(err);
}
}

export function parseMatchDetails(currentMatch) {
  try {
    let matchStats = {};
    if (!currentMatch) return matchStats;
    matchStats.match_title =
      currentMatch?.matchnumber + ", " + currentMatch?.venue;
      const battingscores = currentMatch?.battingTeamStats.split(',').map(s => s.trim());
      const latestScoreBatting = battingscores[battingscores.length - 1];
      const bowlingscores = currentMatch?.bowlingTeamStats.split(',').map(s => s.trim());
      const latestScoreBowling = bowlingscores[bowlingscores.length - 1];


      

    const scoreA = latestScoreBatting?.split(" ")[0] || "";
    const scoreB = latestScoreBowling.split(" ")[0] || "";
    const oversA = latestScoreBatting?.split(" ")[1] || "";
    const oversB = latestScoreBowling?.split(" ")[1] || "";
    const scoreA_2 = currentMatch?.battingTeamStats?.split(",")?.slice(-1)[0].trim() || "";
    const scoreB_2 = currentMatch?.bowlingTeamStats?.split(",")?.slice(-1)[0].trim() || "";

    // const oversA =
    //   (currentMatch?.battingTeamStats?.match(/(\d+\.\d+)/) &&
    //     currentMatch?.battingTeamStats?.match(/(\d+\.\d+)/)[1]) ||
    //   "";
    // const oversB =
    //   (currentMatch?.bowlingTeamStats?.match(/(\d+\.\d+)/) &&
    //     currentMatch?.bowlingTeamStats?.match(/(\d+\.\d+)/)[1]) ||
    //   "";

    function formatDate(dateStr) {
      const [day, month, year] = dateStr
        .split("/")
        .map((num) => num.padStart(2, "0"));
      return `${year}-${day}-${month}`;
    }

    let matchDateIST = currentMatch?.matchdate_ist?.includes("/")
      ? formatDate(currentMatch?.matchdate_ist)
      : currentMatch?.matchdate_ist;
    matchStats.default_date = matchDateIST;
    const matchDateTime = new Date(
      matchDateIST + "T" + currentMatch.reqTime.split("(IST)")[0].trim()
    );

    matchStats.id = currentMatch?.match_id || currentMatch?.match_Id || 0;
    matchStats.type = currentMatch?.matchtype||currentMatch?.matchType;
    matchStats.league_name = currentMatch?.tourname || "IPL";
    matchStats.tossstatus = currentMatch?.tossWonBy || null;
    matchStats.venue = currentMatch?.venue;
    matchStats.match_date = matchDateTime.toLocaleDateString("en-US", {
      weekday: "long",
      month: "short",
      day: "numeric",
    });
    matchStats.match_date_alt = matchDateTime.toLocaleDateString("en-US", {
      weekday: "short",
      day: "2-digit",
      month: "short",
    });
    matchStats.match_date_head = matchDateTime.toLocaleDateString("en-IN", {
      day: "2-digit",
      month: "short",
      year: "numeric",
    });

    matchStats.match_time = matchDateTime.toLocaleTimeString("en-US", {
      hour: "2-digit",
      minute: "2-digit",
      hour12: true,
    });

    matchStats.teamA_name = currentMatch?.teama_short?.toLowerCase();
    matchStats.teamB_name = currentMatch?.teamb_short?.toLowerCase();
    matchStats.altLogoA = currentMatch?.teama_short=="IND"?"https://akm-img-a-in.tosshub.com/lingo/nwtak/resources/1126.png":currentMatch?.teama_short=="ENG"?"https://akm-img-a-in.tosshub.com/lingo/nwtak/resources/1121.png":null;
    matchStats.altLogoB = currentMatch?.teamb_short=="IND"?"https://akm-img-a-in.tosshub.com/lingo/nwtak/resources/1126.png":currentMatch?.teamb_short=="ENG"?"https://akm-img-a-in.tosshub.com/lingo/nwtak/resources/1121.png":null;

    matchStats.teamA_id = currentMatch?.teama_Id;
    matchStats.teamB_id = currentMatch?.teamb_Id;
    matchStats.teamA_fullname = currentMatch?.teama;
    matchStats.teamB_fullname = currentMatch?.teamb;
    matchStats.teamA_score_full =  currentMatch.teama_Id == currentMatch?.current_bowling_team_id
    ? scoreB.includes("To")
      ? "Yet to Bat"
      : (currentMatch?.bowlingTeamStats?.trim() || "")
    : (currentMatch?.battingTeamStats?.trim() || "");

    matchStats.teamB_score_full =  currentMatch.teamb_Id == currentMatch?.current_bowling_team_id
    ? scoreB.includes("To")
      ? "Yet to Bat"
      : (currentMatch?.bowlingTeamStats?.trim() || "")
    : (currentMatch?.battingTeamStats?.trim() || "");

    matchStats.teamA_score =
      currentMatch.teama_Id == currentMatch?.current_bowling_team_id
        ? scoreB.includes("To")
          ? "Yet to Bat"
          : scoreB
        : scoreA;
    matchStats.teamB_score =
      currentMatch.teamb_Id == currentMatch?.current_bowling_team_id
        ? scoreB.includes("To")
          ? "Yet to Bat"
          : scoreB
        : scoreA;
    matchStats.teamA_score_2 = currentMatch.teama_Id == currentMatch?.current_bowling_team_id
    ? scoreB.includes("To")
      ? "Yet to Bat"
      : scoreB_2
    : scoreA_2;
    
    matchStats.teamB_score_2 = currentMatch.teamb_Id == currentMatch?.current_bowling_team_id
    ? scoreB.includes("To")
      ? "Yet to Bat"
      : scoreB_2
    : scoreA_2;

    matchStats.match_no = currentMatch?.matchnumber;
    matchStats.teamA_overs =
      currentMatch.teama_Id == currentMatch?.current_bowling_team_id
        ? scoreB.includes("To")
          ? ""
          : oversB
        : oversA;
    matchStats.teamB_overs =
      currentMatch.teamb_Id == currentMatch?.current_bowling_team_id
        ? scoreB.includes("To")
          ? ""
          : oversB
        : oversA;
    matchStats.live_status =
      currentMatch?.matchStatus || currentMatch?.matchstatus;
    matchStats.equation =
      currentMatch?.equation == "" || !currentMatch?.equation
        ? currentMatch?.matchStatus || currentMatch?.matchstatus
        : currentMatch?.equation;
    matchStats.status = (() => {
          const status = currentMatch?.matchstatus?.toLowerCase() || currentMatch?.matchStatus?.toLowerCase() || "";
          if (status.includes("match ended") || status.includes("match postponed") || status.includes("match abandoned")) {
            return "ENDED";
          }
          if (status.includes("match begins at")) {
            return "UPCOMING";
          }
          return "LIVE";
        })();
      
      const winningTeamId = currentMatch?.Winningteam_id || currentMatch?.Winningteam_Id;
      const teamAId = currentMatch?.teama_id || currentMatch?.teama_Id;
      matchStats.winning_team =
        (matchStats.status == "ENDED" && winningTeamId)
          ? (winningTeamId == teamAId ? "A" : "B")
          : "";
      matchStats.series_id = currentMatch.series_id;
      matchStats.url = `/sports/${currentMatch.series_id=="8307"?"ipl":"cricket"}/${currentMatch?.page_slug_st}/${
            matchStats.status == "UPCOMING"
              ? "info"
              : matchStats.status == "LIVE"
              ? "live"
              : "summary"
          }`;
        
    matchStats.batting_team =
      matchStats.status != "LIVE"
        ? null
        : currentMatch?.current_batting_team == currentMatch?.teama_id ||
          currentMatch?.current_batting_team == currentMatch?.teama_Id
        ? "A"
        : "B";

    //innings details
    matchStats.currentInning =
      currentMatch?.current_inn || currentMatch?.current_inning || null;
    matchStats.inn1_team =
      currentMatch?.FirstInnings?.tab?.batting_team_header || null;
    matchStats.inn2_team =
      currentMatch?.SecondInnings?.tab?.batting_team_header || null;
    matchStats.inn3_team = currentMatch?.ThirdInnings?.tab?.batting_team_header||null;
    matchStats.inn4_team = currentMatch?.FourthInnings?.tab?.batting_team_header||null;
    
    matchStats.inn1_score = (currentMatch?.FirstInnings?.tab?.tabScore?.split("-")[1]+ " ("+currentMatch?.FirstInnings?.node?.extras?.overs+")")||""
    matchStats.inn2_score = (currentMatch?.SecondInnings?.tab?.tabScore?.split("-")[1]+" ("+currentMatch?.SecondInnings?.node?.extras?.overs+")")||""       
    matchStats.inn3_score = (currentMatch?.ThirdInnings?.tab?.tabScore?.split("-")[1]+" ("+currentMatch?.ThirdInnings?.node?.extras?.overs+")")||""
    matchStats.inn4_score = (currentMatch?.FourthInnings?.tab?.tabScore?.split("-")[1]+" ("+currentMatch?.FourthInnings?.node?.extras?.overs+")")||""
    
    matchStats.inn1_batsmen =
      currentMatch.FirstInnings?.node?.allBatsmen?.map((batsman) => ({
        batsmanId: batsman.Batsman_Id,
        batsmanName: batsman.Batsman,
        striker: batsman.Striker,
        runs: batsman?.Runs,
        ballsFaced: batsman?.BallsFaced,
        howOut: batsman?.Howout,
        fours: batsman?.Fours,
        sixes: batsman?.Sixes,
        sr: batsman?.Striker_SR,
      })) || [];
    matchStats.inn2_batsmen =
      currentMatch.SecondInnings?.node?.allBatsmen?.map((batsman) => ({
        batsmanId: batsman.Batsman_Id,
        batsmanName: batsman.Batsman,
        striker: batsman.Striker,
        runs: batsman?.Runs,
        ballsFaced: batsman?.BallsFaced,
        howOut: batsman?.Howout,
        fours: batsman?.Fours,
        sixes: batsman?.Sixes,
        sr: batsman?.Striker_SR,
      })) || [];

    matchStats.inn1_yetToBat = matchStats?.inn1_batsmen?.filter(
      (item) => !item.howOut || item.howOut == ""
    );
    matchStats.inn2_yetToBat = matchStats?.inn2_batsmen?.filter(
      (item) => !item.howOut || item.howOut == ""
    );

    matchStats.inn3_batsmen =
      currentMatch.ThirdInnings?.node?.allBatsmen?.map((batsman) => ({
        batsmanId: batsman.Batsman_Id,
        batsmanName: batsman.Batsman,
        striker: batsman.Striker,
        runs: batsman?.Runs,
        ballsFaced: batsman?.BallsFaced,
        howOut: batsman?.Howout,
        fours: batsman?.Fours,
        sixes: batsman?.Sixes,
        sr: batsman?.Striker_SR,
      })) || [];

    matchStats.inn4_batsmen =
      currentMatch.FourthInnings?.node?.allBatsmen?.map((batsman) => ({
        batsmanId: batsman.Batsman_Id,
        batsmanName: batsman.Batsman,
        striker: batsman.Striker,
        runs: batsman?.Runs,
        ballsFaced: batsman?.BallsFaced,
        howOut: batsman?.Howout,
        fours: batsman?.Fours,
        sixes: batsman?.Sixes,
        sr: batsman?.Striker_SR,
      })) || [];

    matchStats.inn3_yetToBat = matchStats?.inn3_batsmen?.filter(
      (item) => !item.howOut || item.howOut == ""
    );
    matchStats.inn4_yetToBat = matchStats?.inn4_batsmen?.filter(
      (item) => !item.howOut || item.howOut == ""
    );

    matchStats.inn1_batsmen = matchStats.inn1_batsmen.filter(
      (batsman) => batsman.runs && batsman.ballsFaced
    );
    matchStats.inn2_batsmen = matchStats.inn2_batsmen.filter(
      (batsman) => batsman.runs && batsman.ballsFaced
    );

    matchStats.inn1_bowlers =
      currentMatch.FirstInnings?.node?.allBowlers?.map((bowler) => ({
        bowlerId: bowler?.Bowler_Id,
        bowlerName: bowler?.BowlersName,
        overs: bowler.Overs,
        maidens: bowler?.Maidens,
        bowling: bowler?.Bowling,
        bowlers: bowler?.Bowlers,
        runsGiven: bowler?.Runsgiven,
        wickets: bowler?.Wickets,
        econ: bowler?.Econ,
      })) || [];

    matchStats.inn2_bowlers =
      currentMatch.SecondInnings?.node?.allBowlers?.map((bowler) => ({
        bowlerId: bowler?.Bowler_Id,
        bowlerName: bowler?.BowlersName,
        overs: bowler.Overs,
        maidens: bowler?.Maidens,
        bowling: bowler?.Bowling,
        bowlers: bowler?.Bowlers,
        runsGiven: bowler?.Runsgiven,
        wickets: bowler?.Wickets,
        econ: bowler?.Econ,
      })) || [];

      matchStats.inn3_bowlers =
      currentMatch.ThirdInnings?.node?.allBowlers?.map((bowler) => ({
        bowlerId: bowler?.Bowler_Id,
        bowlerName: bowler?.BowlersName,
        overs: bowler.Overs,
        maidens: bowler?.Maidens,
        bowling: bowler?.Bowling,
        bowlers: bowler?.Bowlers,
        runsGiven: bowler?.Runsgiven,
        wickets: bowler?.Wickets,
        econ: bowler?.Econ,
      })) || [];

    matchStats.inn4_bowlers =
      currentMatch.FourthInnings?.node?.allBowlers?.map((bowler) => ({
        bowlerId: bowler?.Bowler_Id,
        bowlerName: bowler?.BowlersName,
        overs: bowler.Overs,
        maidens: bowler?.Maidens,
        bowling: bowler?.Bowling,
        bowlers: bowler?.Bowlers,
        runsGiven: bowler?.Runsgiven,
        wickets: bowler?.Wickets,
        econ: bowler?.Econ,
      })) || [];

    function parseExtras(extrasString) {
      if (!extrasString) return { w: 0, b: 0, lb: 0, nb: 0 };

      const matches = extrasString.match(/\w+\s+\d+/g) || [];
      const extras = {};

      matches.forEach((match) => {
        const [key, value] = match.split(/\s+/);
        extras[key] = Number(value);
      });

      return {
        w: extras.w || 0,
        b: extras.b || 0,
        lb: extras.lb || 0,
        nb: extras.nb || 0,
      };
    }

    let inn1Extras = currentMatch?.FirstInnings?.node?.extras?.extras;
    matchStats.inn1_extras = {
      ...parseExtras(inn1Extras),
      runs: currentMatch?.FirstInnings?.node?.extras?.extra_run || 0,
    };

    let inn2Extras = currentMatch?.SecondInnings?.node?.extras?.extras;
    matchStats.inn2_extras = {
      ...parseExtras(inn2Extras),
      runs: currentMatch?.SecondInnings?.node?.extras?.extra_run || 0,
    };

    let inn3Extras = currentMatch?.ThirdInnings?.node?.extras?.extras;
    matchStats.inn1_extras = {
      ...parseExtras(inn3Extras),
      runs: currentMatch?.ThirdInnings?.node?.extras?.extra_run || 0,
    };

    let inn4Extras = currentMatch?.FourthInnings?.node?.extras?.extras;
    matchStats.inn2_extras = {
      ...parseExtras(inn4Extras),
      runs: currentMatch?.FourthInnings?.node?.extras?.extra_run || 0,
    };

    //head to head stats
    const headToHead = currentMatch?.head_to_head_data || [];
    if (headToHead && headToHead?.length) {
      matchStats.teamA_wins_h2h = headToHead.filter(
        (match) => match.winningteam_id == currentMatch?.teama_Id
      ).length;
      matchStats.teamB_wins_h2h = headToHead.filter(
        (match) => match.winningteam_id == currentMatch?.teamb_Id
      ).length;
      matchStats.matches_h2h = [];
      for (let match of headToHead) {
        const matchdt = match.matchdate_ist + "T" + match.matchtime_ist;
        const matchDay = new Date(matchdt).toLocaleDateString("en-us", {
          day: "numeric",
          month: "short",
        });
        const matchObj = {
          league_name: match.tourname,
          teamA_score:
            (match.inn_team_1 == currentMatch?.teama_Id||match.inn_team_1 == currentMatch?.teama_id)? match.inn_score_1: match.inn_score_2,
          teamB_score:
            (match.inn_team_1 == currentMatch?.teamb_Id||match.inn_team_1 == currentMatch?.teamab_id)? match.inn_score_1: match.inn_score_2,
          result: match.matchresult,
          match_title: match.tourname + " on " + matchDay,
        };
        matchStats?.matches_h2h.push(matchObj);
      }
    }
    matchStats.umpires = currentMatch?.Umpires || null;
    matchStats.referee = currentMatch?.Referee || null;
    matchStats.manOfMatch = currentMatch?.ManoftheMatch || null;
    matchStats.manOfMatchId = currentMatch?.ManoftheMatch_player_id || null;
    matchStats.crr = currentMatch?.currInnRunRate || null;
    const overNodes = currentMatch?.top_commentry_node?.overDetail || null;

    if (overNodes) {
      matchStats.over_details = [];
      matchStats.commentary = [];

      Object.entries(overNodes).forEach(([over, deliveries]) => {
        if (!over || !deliveries?.length) return; // Skip invalid or empty overs

        let totalRuns = 0;
        const overStats = [];
        const comms = [];

        deliveries.forEach((item) => {
          const runs =
            item?.Runs?.includes("W") && !item?.Runs?.includes("WD")
              ? "W"
              : item?.Runs;
          if (!isNaN(Number(item.Runs.substring(0, 1))))
            totalRuns += Number(item.Runs.substring(0, 1));

          overStats.push({
            over: `Over ${item.Over_Ordinal}`,
            runs: runs,
          });

          if (item.highlights) {
            const commText =
              item.highlights.split(":")[1]?.trim().split(",") || [];

            const firstPart = commText[0]?.trim() || "";
            const secondPart = commText.slice(1, -1).join(" ").trim() || "";
            const finalPart = commText[commText.length - 1]?.trim() || "";

            comms.push({
              currBall:
                item.highlights?.split(":")[0] || `${item.Over}.${item.Ball}`,
              runs: runs,
              commSpeakers: firstPart,
              commHighlight: secondPart,
              comment: finalPart,
            });
          }
        });

        matchStats.commentary.push(...comms);
        matchStats.over_details.push({ overStats, overTotal: totalRuns });
      });
      matchStats.commentary = matchStats.commentary.reverse();
      matchStats.over_details = matchStats.over_details.reverse();
    }
    matchStats.inn1_notes = currentMatch?.FirstInnings?.node?.notes || null;
    matchStats.inn2_notes = currentMatch?.SecondInnings?.node?.notes || null;
    matchStats.inn3_notes = currentMatch?.ThirdInnings?.node?.notes || null;
    matchStats.inn4_notes = currentMatch?.FourthInnings?.node?.notes || null;

    return matchStats;
  } catch (err) {
    console.log(err);
  }
}

export function parseCommentary(rawCommentaryData) {
  const formattedCommentary = {};
  // Process each over's commentary data
  rawCommentaryData.forEach((overData) => {
    Object.keys(overData).forEach((ballKey) => {
      if (ballKey === "detail" || ballKey === "summary" || !overData[ballKey])
        return; // Skip the invalid objects

      const ballData = overData[ballKey];
      const commentaryParts = ballData.commentary_data?.split(": ");
      if (ballData.ball_no) {
        const overBall = commentaryParts[0]; // Example: "18.1"
        const commentaryText = commentaryParts[1]; // Actual commentary text
        const commText = commentaryText?.split(",");

        const firstPart = commText[0]?.trim() || "";
        const secondPart = commText.slice(1, -1).join(" ").trim() || "";
        const finalPart = commText[commText.length - 1]?.trim() || "";

        const [overNo, ballNo] = overBall?.split(".").map(Number);

        if (!formattedCommentary[overNo]) {
          formattedCommentary[overNo] = {
            balls: [],
            over_summary: {
              over: overNo,
              summary: [],
            },
          };
        }

        formattedCommentary[overNo].balls.push({
          ball: overNo.toString() + "." + ballNo.toString(),
          runs: ballData.run || 0,
          wicket: ballData.wicket || "No",
          commSpeakers: firstPart || "",
          commHighlight: secondPart || "",
          comment: finalPart || "",
        });
        // Add to over summary
        formattedCommentary[overNo].over_summary.summary.push(
          ballData.wicket === "Yes" ? "W" : ballData.run
        );
      } else {
        // other commentary (pre-match, extra balls, etc)
        if (!formattedCommentary["extras"]) {
          formattedCommentary["extras"] = {
            balls: [],
            over_summary: {
              summary: [],
            },
          };
        }
        formattedCommentary["extras"].balls.push({
          ball: null,
          runs: null,
          wicket: null,
          commSpeakers: null,
          commHighlight: null,
          comment: ballData.commentary_data,
        });
      }
    });
  });
  const comms = Object.values(formattedCommentary).map((comm) => ({
    balls: comm.balls.reverse(),
    over_summary: comm.over_summary,
  }));
  const extraComms = [comms.pop()];
  const structuredCommentary = comms.reverse();
  return [...structuredCommentary, ...extraComms];
}
